import http from "../api/apiClient";

export type EntityId = string | number;

export interface MyClassroomTeacher {
  id?: EntityId;
  uuid?: EntityId;
  firstName?: string;
  firstname?: string;
  lastName?: string;
  lastname?: string;
  fullName?: string;
  displayName?: string;
  email?: string;
}

export interface MyClassroomChild {
  id?: EntityId;
  uuid?: EntityId;
  firstName?: string;
  firstname?: string;
  lastName?: string;
  lastname?: string;
  dateBirth?: string;
  familyId?: EntityId | null;
  familyUuid?: EntityId | null;
  familyName?: string | null;
  parents?: MyClassroomParent[];
}

export interface MyClassroomParent {
  id?: EntityId;
  uuid?: EntityId;
  firstName?: string;
  firstname?: string;
  lastName?: string;
  lastname?: string;
  email?: string | null;
  phone?: string | null;
}

export interface MyClassroom {
  id?: EntityId;
  uuid?: EntityId;
  classroomId?: EntityId;
  classroomUuid?: EntityId;
  className?: string;
  classroomName?: string;
  name?: string;
  label?: string;
  classType?: string;
  grade?: number;
  startDate?: string | null;
  endDate?: string | null;
  schoolYearId?: EntityId | null;
  schoolYearName?: string | null;
  childCount?: number;
  familyCount?: number;
  childrenCount?: number;
  pupilCount?: number;
  studentCount?: number;
  parentMeetingCount?: number;
  openParentMeetingCount?: number;
  outingCount?: number;
  activeOutingCount?: number;
  teachers?: MyClassroomTeacher[];
  children?: MyClassroomChild[];
  [key: string]: unknown;
}

function normalizeArray<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[];
  if (Array.isArray((data as any)?.content)) return (data as any).content;
  if (Array.isArray((data as any)?.items)) return (data as any).items;
  if (Array.isArray((data as any)?.data)) return (data as any).data;
  if (Array.isArray((data as any)?.classrooms)) return (data as any).classrooms;
  return [];
}

export function getClassroomId(classroom: MyClassroom): string {
  const value =
    classroom.uuid ??
    classroom.id ??
    classroom.classroomUuid ??
    classroom.classroomId ??
    "";
  return String(value);
}

export function getClassroomName(classroom: MyClassroom): string {
  return String(
    classroom.className ||
      classroom.classroomName ||
      classroom.name ||
      classroom.label ||
      "Classroom"
  );
}

export function getChildCount(classroom: MyClassroom): number {
  const direct =
    classroom.childCount ??
    classroom.childrenCount ??
    classroom.pupilCount ??
    classroom.studentCount;

  if (typeof direct === "number") return direct;
  if (Array.isArray(classroom.children)) return classroom.children.length;
  return 0;
}

export async function listMyClassrooms(): Promise<MyClassroom[]> {
  // Preferred endpoint for the new My environment.
  // Backend should return only classrooms related to the authenticated teacher.
  const { data } = await http.get("/me/classrooms");
  return normalizeArray<MyClassroom>(data);
}
